import React from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { RolePermissionItem } from "../RolePermissionItem";

export function ListRolePermission(props) {
  const { section, rolePermissions, onReload } = props;

  if (!section) return "Selecciona un módulo";
  if (!rolePermissions) return <Loader active inline="centered" />;
  if (size(rolePermissions) === 0) return "No se ha encontrado permisos relacionados a esta sección.";

  return map(rolePermissions, (rolePermission) => (
    <RolePermissionItem key={rolePermission.id} rolePermission={rolePermission} onReload={onReload} />
  )); 
}
